<template>
    <div class="p-d-flex p-jc-between">    
        <div class="p-mt-5 box-status">
            Página {{ paginaAtiva }} de {{ totalPaginas }} de {{ totalLinhas }} registros   
        </div>
        <div class="box-status">            
            <div class="p-formgroup-inline">
                <div class="p-field p-mt-4 p-mb-0">
                    <label>Página</label>
                    <Dropdown v-model="paginaSelecionada" :options="linksPaginas" 
                        optionLabel="pagina" optionValue="pagina" class="p-ml-2" @change="filtrarPagina"/>
                </div>
                <div class="p-field p-mt-4 p-mb-0">
                    <label>Linhas por Página</label>
                    <Dropdown v-model="linhasPorPaginaSelecionada" :options="linhasPorPagina" 
                        optionLabel="nome" optionValue="linhas" class="p-ml-2" @change="paginar(1)"/>                
                </div>
            </div>        
        </div>
    </div>  
</template>

<script>
export default {
    props: {
        qtdLinhasPorPagina: {
            type: Array,
            required: true,
        },
        callback: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            naoVoltar: true,
            naoAvancar: true,
            totalLinhas: 0,           
            totalPaginas: 0,
            paginaSelecionada: 1,
            paginaAtiva: 0, 
            linksPaginas: [],
            linhasPorPaginaSelecionada: 0,
            linhasPorPagina: [],
        }
    },
    methods: {
        paginarSemAtualizarDados(numPagina) {
            if(numPagina == 1) {
                this.naoVoltar = true;
            } else if(this.paginaAtiva == 1){
                this.naoVoltar = false;
            }
            if(numPagina == this.totalPaginas) {
                this.naoAvancar = true;
            } else if(this.paginaAtiva == this.totalPaginas){
                this.naoAvancar = false;
            }
            this.paginaAtiva = numPagina;    
            this.paginaSelecionada = numPagina;       
        },
        filtrarPagina() {
            this.paginar(this.paginaSelecionada);
        },
        paginar(numPagina) {
            if(numPagina == 1) {
                this.naoVoltar = true;
            } else if(this.paginaAtiva == 1){
                this.naoVoltar = false;
            }
            if(numPagina == this.totalPaginas) {
                this.naoAvancar = true;
            } else if(this.paginaAtiva == this.totalPaginas){
                this.naoAvancar = false;
            }
            this.paginaAtiva = numPagina;
            this.callback({pagina:numPagina, linhas: this.linhasPorPaginaSelecionada});
        },        
        voltar() {         
            if(this.naoVoltar) {
                return;
            }
            this.paginaAtiva--;
            if(this.paginaAtiva == 1) {
                this.naoVoltar = true;
            }
            if(this.naoAvancar) {
                this.naoAvancar = false;
            }           
            this.callback({pagina:this.paginaAtiva, linhas: this.linhasPorPaginaSelecionada});
        },
        inicio() {
            if(this.naoVoltar) {
                return;
            }
            if(this.naoAvancar) {
                this.naoAvancar = false;
            }
            this.naoVoltar = true;
            this.paginaAtiva = 1;
            this.callback({pagina:1, linhas: this.linhasPorPaginaSelecionada});
        },
        avancar() {
            if(this.naoAvancar) {
                return;
            }            
            this.paginaAtiva++;
            if(this.paginaAtiva == this.totalPaginas) {
                this.naoAvancar = true;
            }
            if(this.naoVoltar) {
                this.naoVoltar = false;
            }           
            this.callback({pagina:this.paginaAtiva, linhas: this.linhasPorPaginaSelecionada});
        },
        final() {
            if(this.naoAvancar) {
                return;
            }
            if(this.naoVoltar) {
                this.naoVoltar = false;
            }
            this.naoAvancar = true;
            this.paginaAtiva = this.totalPaginas;
            this.callback({pagina:this.totalPaginas, linhas: this.linhasPorPaginaSelecionada});
        },
        atualizar(pTotalLinhas) {          
            if(pTotalLinhas > 0) {
                this.totalLinhas = pTotalLinhas;
                let result = this.totalLinhas / this.linhasPorPaginaSelecionada;                      
                if((parseInt(result) * this.linhasPorPaginaSelecionada) == this.totalLinhas) {
                    this.totalPaginas = parseInt(this.totalLinhas / this.linhasPorPaginaSelecionada);
                } else {
                    this.totalPaginas = parseInt((this.totalLinhas / this.linhasPorPaginaSelecionada)) + 1;
                }
            }     
            if(pTotalLinhas != this.totalLinhas) {
                this.paginaAtiva = 1;                
            }           
            this.linksPaginas = [];
            for(let i = 0; i < this.totalPaginas; i++) {
                this.linksPaginas.push({pagina:(i+1)});
            }     
            if(this.paginaAtiva == 0 && this.linksPaginas.length > 0) {
                this.paginaAtiva = 1;
            }
            if(this.totalPaginas == 1) {
                this.naoAvancar = true;
                this.naoVoltar = true;
            } else if(this.totalPaginas > 1 && this.naoAvancar && (this.paginaAtiva < this.totalPaginas)) {
                this.naoAvancar = false;
            }  
            this.paginaSelecionada = this.paginaAtiva;
        },        
    },
    created() {               
        this.qtdLinhasPorPagina.forEach(item => {
            this.linhasPorPagina.push({linhas: item, nome: item});
        });         
    },
    mounted() {
        this.atualizar(0);
        this.linhasPorPaginaSelecionada = this.qtdLinhasPorPagina[0];
    }
}
</script>

<style>

    .box-status {
        color: #6C757D;
    }

    .link-pagina-ativa {
        background-color: #1B8AED;
        color: #ffffff !important;
        border-radius: 3px;
    }

    .link-pagina-ativa a {
        background-color: #1B8AED;
        color: #ffffff !important;
    }

    .link {
        text-decoration: none;
        color:#74757D;
    }

    .box-link {        
        padding: 9px;
    }

    .box-link-click:hover{
        cursor:  pointer;
    }

    .box-link-pagina {        
        padding-left: 15px;
        padding-right: 15px;
        padding-top: 9px;
        padding-bottom: 9px;
    }

    .sem-link {
        text-decoration: none;
        color: #c2c2c2;
    }

</style>